import { getInstantRentingStatus } from '../../shared/reducers/config.selector'
import { getRegionInstantRentingStatus } from '../../shared/reducers/regions.selector'

export const instantBookingEnabledSelector = (state, regionId) =>
  getInstantRentingStatus(state) &&
  getRegionInstantRentingStatus(state, regionId)
